import { Typography } from "@mui/material";

// Remove the <a> tag from data
export const parseAnchor = (htmlString) => {
  const div = document.createElement("div");
  div.innerHTML = htmlString;
  const a = div.querySelector("a");
  return a ? { href: a.href, text: a.textContent } : null;
};

// Format currency
export const formatCurrency = (value) => {
  if (value == null) return "-";

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(value);
};

// Format percentage
export const formatPercentage = (value) => {
  if (value == null) return "-";
  return `${(value * 100).toFixed(2)}%`;
};

// Validate website value
export const getWebsiteValue = (item) => {
  const website = item.Website || item.website || "";
  return website;
};
export const isValidWebsite = (website) => {
  return (
    website &&
    website !== "" &&
    website !== "None" &&
    website !== "*" &&
    !website.includes("*")
  );
};

// Check if data is empty or invalid
export const isDataEmpty = (data) => {
  if (data === null || data === undefined || data === "") return true;
  if (Array.isArray(data) && data.length === 0) return true;
  if (typeof data === "object" && Object.keys(data).length === 0) return true;
  return false;
};

// Build taxonomy path string from form values
export function buildTaxonomyPath(formValues) {
  return [formValues.category, formValues.L2, formValues.L3, formValues.L4]
    .filter(Boolean)
    .join(" > ");
}

// ----------------------------------- TABLE CUT TEXT LENGTH ---------------------------------------------

export const getDisplayText = (text, maxLength) => {
  if (!text) return "-";
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

// Determines if a background colour is dark or light
export const isBackgroundDark = (rgbString) => {
  const match = rgbString.match(/\d+/g); // Search for matches, pulling out the RGB values
  if (!match) return true;
  const [r, g, b] = match.map(Number);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255; // Calculate an approcimation for luminance, if it's dark or light - (W3C formula idea)
  return luminance < 0.5; // < 50% is dark
};

// Create path string for taxonomy based on selected values
export const createTaxonomyPath = (values, accountInfo) => {
  const showTaxPath = [];
  if (values.category) showTaxPath.push(values.category);
  if (values.L2) showTaxPath.push(values.L2);
  if (values.L3) showTaxPath.push(values.L3);
  if (accountInfo?.haveL4 && values.L4) showTaxPath.push(values.L4);

  return showTaxPath.length > 0 ? showTaxPath.join(" > ") : "";
};

// Render text with bold formatting for lines ending with ":" (excluding bullet points)
export const boldColonHeadings = (text) => {
  if (!text) return text;

  return text.split("\n").map((line, index) => {
    const trimmedLine = line.trim();

    if (trimmedLine.endsWith(":") && !trimmedLine.startsWith("\u2022")) {
      return (
        <Typography key={index} sx={{ fontWeight: "bold" }} component="div">
          {line}
        </Typography>
      );
    }

    return (
      <Typography key={index} component="div">
        {line}
      </Typography>
    );
  });
};

// After clicking a link change the colour for the user to see it's been clicked
export const isLinkClicked = (href, clickedSet) => clickedSet.has(href);

export const markLinkClicked = (href, clickedSet, setClickedSet) => {
  const newSet = new Set(clickedSet);
  newSet.add(href);
  setClickedSet(newSet);
};

// Style Capitalization
export const capitalizeWords = (str) => {
  try {
    if (!str || typeof str !== "string") return "";

    const acronyms = [
      "ATL",
      "AB",
      "BTL",
      "GFR",
      "HR",
      "MRO",
      "IT",
      "IP",
      "IVMS",
      "UPS",
      "PCs",
      "PC",
      "POS",
      "PPE",
      "PFI",
      "PR",
      "3PL",
      "OOH",
      "O&G",
      "OCTG",
      "MDS",
      "LPG",
      "LCV",
      "LTL",
      "HGV",
      "HDPE",
      "CSR",
      "CCTV",
      "FM",
      "FTL",
      "UODs",
      "TV",
      "TMC",
      "SVCS",
      "eCommerce",
      "EPC",
    ];

    return str
      .split(" ")
      .map((word) => {
        const upper = word.toUpperCase();
        // If matches an acronym, keep it fully uppercase
        if (acronyms.includes(upper)) return upper;
        // Otherwise capitalize normally
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  } catch (error) {
    console.error("Error capitalizing words: ", error);
    return str || "";
  }
};
